module.exports = __webpack_public_path__ + "img/1449947569.cdf7af41.jpg";